<template>
  <div class="mobile_box_class">
    <div class="d-flex pa-2" v-if="tabValue == 'Active'">
      <div>
        <div class="label_class">Total Margin</div>
        <div class="val__class normal_val_color">
          {{ totalMargin | addCommaDecimal }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="text-right">
        <div class="label_class">Available Margin</div>
        <div class="val__class normal_val_color">
          {{ availableMargin | addCommaDecimal }}
        </div>
      </div>
    </div>
    <div v-else class="d-flex pa-2">
      <div>
        <div class="label_class">Invested Amount</div>
        <div class="val__class normal_val_color">
          {{ investedMargin | addCommaDecimal }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="text-right">
        <div class="label_class">Current Amount</div>
        <div class="val__class normal_val_color">
          {{ currentAmount | addCommaDecimal }}
        </div>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="d-flex pa-2" v-if="tabValue == 'Active'">
      <div>
        <div class="label_class">Invested Margin</div>
        <div class="val__class normal_val_color">
          {{ investedMargin | addCommaDecimal }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="text-right">
        <div class="label_class">P&L</div>
        <div
          class="val__class"
          :class="pandl >= 0 ? 'positive_color' : 'negative_color'"
        >
          {{ pandl | addCommaDecimal }} ({{ pandlPercent | addCommaDecimal }}%)
        </div>
      </div>
    </div>
    <div v-else class="d-flex pa-2">
      <div class="label_class">P&L</div>
      <v-spacer></v-spacer>
      <div
        class="val__class"
        :class="pandl >= 0 ? 'positive_color' : 'negative_color'"
      >
        {{ pandl | addCommaDecimal }} ({{ pandlPercent | addCommaDecimal }}%)
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SummaryFigureMobile",
  props: {
    totalMargin: {
      default: 0,
    },
    availableMargin: {
      default: 0,
    },
    investedMargin: {
      default: 0,
    },
    pandl: {
      default: 0,
    },
    pandlPercent: {
      default: 0,
    },
    currentAmount: {
      default: 0,
    },
    tabValue: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped>
.mobile_box_class {
  border-radius: 8px;
  background: #f5f5f5;
}
.label_class {
  color: rgba(51, 51, 51, 0.66);

  font-family: Avenir;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.val__class {
  font-family: Avenir;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.normal_val_color {
  color: var(--Button-Black, #283037);
}
.positive_color {
  color: var(--Green-2, #27ae60);
}
.negative_color {
  color: var(--Red, #eb5757);
}
</style>
